<template>
  <Dialog modal dismissableMask position="top" header="Bins" :closable="false" v-model:visible="visible">
    <template #header>
      <h3>
        Bins
      </h3>
      <div style="flex-grow: 1"></div>
      <!-- <Button size="small" severity="secondary" style="justify-content: center;" @click="addBin()">
        <i class="pi pi-plus"></i>
        Add bin
      </Button> -->
    </template>
    <div ref="dialogBody">
      <ul style="display: flex; flex-direction: column; gap: 10px;">
        <TransitionGroup>
          <li v-for="(bin, binIndex) in bins" :key="bin.handle" style="display: flex; align-items: center; gap: 10px;">
            <InputText v-model="bin.name.value" @input="showSubmit = true" style="width: 250px;"></InputText>
            <Button v-if="bins.length > 1" severity="secondary" style="justify-content: center; width: 60px; height: 40px;" @click="onClickOrdinal($event, binIndex)">
              <span v-html="ordinalLabel(binIndex)"></span>
            </Button>
            <Button severity="secondary" style="justify-content: center; width: 60px; height: 40px;" @click="cloneBin(bin)">
              <i class="pi pi-clone"></i>
            </Button>
            <Button severity="secondary" style="justify-content: center; width: 60px; height: 40px;" @click="removeBin(bin)">
              <i class="pi pi-trash"></i>
            </Button>
          </li>
        </TransitionGroup>
        <Menu ref="ordinalMenu" popup :model="ordinalMenuItems">
          <template #item="{item, props}">
            <a v-ripple v-bind="props.action">
              <span v-html="item.label"></span>
            </a>
          </template>
        </Menu>
        <div style="display: flex;">
          <Button severity="secondary" style="flex-grow: 1; justify-content: center;" @click="addBin()">
            <i class="pi pi-plus"></i>
            Add bin
          </Button>
        </div>
      </ul>
      <div style="margin-top: 15px; display: flex; justify-content: flex-end;">
        <Button style="width: 60px; justify-content: center;" @click="ok()">
          Ok
        </Button>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, ref } from "vue";
import { promiseTimeout } from "@vueuse/core";
import { arrayMove, swap } from "./utility.js";
import { showSubmit, systemCopy, updatePlaceholders } from "./ChannelAssignments.vue";
import store from "./store.js";
import Tag from "./Tag.js";

let props = defineProps([
  "visible"
]);

let visible = defineModel("visible");

let bins = computed(() => {
  return systemCopy.value.bins.children;
});

function ordinalLabel(index) {
  let suffix = null;
  let ordinalIndex = index + 1;
  switch (ordinalIndex) {
    case 1: suffix = "st"; break;
    case 2: suffix = "nd"; break;
    case 3: suffix = "rd"; break;
    default: suffix = "th"; break;
  }
  return `${ordinalIndex}<sup>${suffix}</sup>`;
}

let ordinalMenu = ref();
let ordinalMenuItems = ref([]);
function onClickOrdinal(event, binIndex) {
  if (bins.value.length == 2) {
    swap(bins.value, 0, 1);
    showSubmit.value = true;
  }
  else {
    ordinalMenuItems.value = bins.value.map((bin, index) => ({
      label: ordinalLabel(index),
      command: () => {
        arrayMove(bins.value, binIndex, index);
        showSubmit.value = true;
      }
    }));
    ordinalMenu.value.toggle(event);
  }
}

let dialogBody = ref();
async function addBin() {
  let binTemplate = systemCopy.value.tagJsonTemplates.value.bin;
  let bin = new Tag(store.sessions[0], systemCopy.value.bins, binTemplate);
  bin.name.value = `Bin ${bins.value.length + 1}`;
  bins.value.push(bin);
  updatePlaceholders();
  showSubmit.value = true;

  await promiseTimeout();
  dialogBody.value.querySelector("input:last-of-type").focus();

}

function removeBin(bin) {
  systemCopy.value.bins.children = bins.value.filter(other => other != bin);
  showSubmit.value = true;
}

function cloneBin(bin) {
  let clone = bin.$clone();
  clone.name.value = `Bin ${bins.value.length + 1}`;
  bins.value.push(clone);
  showSubmit.value = true;
}

function ok() {
  bins.value.forEach(bin => {
    bin.name.value = bin.name.value.trim();
  });
  
  visible.value = false;
  // let connectedSessions = store.sessions.filter(session => session.isConnected);
  // connectedSessions.forEach(session => {
  //   let system = session.system;
  //   let bin = bins.value.find(other => other.macAddress.value == system.macAddr.value);
  //   session.changeSettings([
  //     { handle: system.name.handle, value: bin.name.value },  // Change the bin name if required.
  //     { handle: system.bins.handle, value: bins.value }   // Change the bins list.
  //   ]);
  // });
}

function cancel() {
  visible.value = false;
}
</script>

<style scoped>
.v-move,
.v-enter-active,
.v-leave-active,
.p-inputtext {
  transition: all 0.25s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.v-leave-active {
  position: absolute;
}
</style>